"use client";

import { useQuery } from "@tanstack/react-query";

import {
  getLocationProvidersInstructions,
  type LocationProvidersInstructionsResult,
} from "@/src/requests/location-providers-instructions";

export function useLocationProvidersInstructions(locationId: string | null) {
  return useQuery<LocationProvidersInstructionsResult>({
    queryKey: ["location-providers-instructions", locationId],
    queryFn: () => getLocationProvidersInstructions(locationId),
    staleTime: 5 * 60 * 1000,
  });
}
